import React, { useState } from 'react';
import { Form, InputNumber, DatePicker, Button, Card, Typography, message, Space } from 'antd';
import { setRevenue_amount } from '@/api/Admin/revenue';
import moment from 'moment';

const { Title } = Typography;

const RevenueManagementPage: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values: any) => {
        setLoading(true);
        try {
            const { amount, date } = values;
            await setRevenue_amount(amount, date.toDate());
            form.resetFields();
        } catch (error) {
            console.error('Failed to set revenue:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '24px' }}>
            <Card style={{ maxWidth: 600, margin: '0 auto' }}>
                <Title level={2}>Set Monthly Revenue</Title>
                <p style={{ marginBottom: 24, color: '#666' }}>
                    Input the total revenue amount for a specific month to calculate member commissions.
                </p>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        date: moment(),
                    }}
                >
                    <Form.Item
                        label="Revenue Amount"
                        name="amount"
                        rules={[
                            { required: true, message: 'Please input the revenue amount!' },
                            { type: 'number', min: 0, message: 'Amount must be greater than or equal to 0' }
                        ]}
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value!.replace(/\$\s?|(,*)/g, '')}
                            placeholder="e.g. 1,000,000"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="RM_Team"
                        name="rm_team"
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `${value}`}
                            parser={value => value!.replace('', '')}
                            placeholder="e.g. 8"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Reference Date"
                        name="date"
                        rules={[{ required: true, message: 'Please select a date!' }]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            picker="date"
                            size="large"
                            format="YYYY-MM-DD"
                        />
                    </Form.Item>

                    <Form.Item style={{ marginTop: 32 }}>
                        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                            <Button onClick={() => form.resetFields()}>
                                Reset
                            </Button>
                            <Button type="primary" htmlType="submit" loading={loading} size="large">
                                Submit Revenue
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default RevenueManagementPage;
